export enum MeetingsToolsParamsType {
    Empty,
    OpenWizard,
}

export interface MeetingsToolsParamsBase {
    type: MeetingsToolsParamsType;
}

export interface EmptyParams extends MeetingsToolsParamsBase {
    type: MeetingsToolsParamsType.Empty;
}

export interface OpenWizardParams extends MeetingsToolsParamsBase {
    type: MeetingsToolsParamsType.OpenWizard;
    otherAttendeeId: number;
}

export type MeetingsToolsParams = EmptyParams | OpenWizardParams;
